/**
 * Registers the service worker (offline shell, Web Push, share target) through the Trusted
 * Types policy. `injectRegister: null` in vite.config keeps vite-plugin-pwa from adding an
 * inline script, so the page stays CSP-clean.
 */
import { scriptURL } from './trusted-types.js'

export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) return null
  const dev = import.meta.env.DEV
  if (dev && !import.meta.env.VITE_SW_DEV) return null
  try {
    return await navigator.serviceWorker.register(scriptURL(dev ? '/dev-sw.js?dev-sw' : '/sw.js'), {
      type: dev ? 'module' : 'classic',
      scope: '/',
      updateViaCache: 'none',
    })
  } catch (e) {
    console.warn('service worker registration failed', e)
    return null
  }
}

/** Messages from the service worker (notification clicks) → in-app navigation. */
export function onServiceWorkerMessage(
  cb: (msg: { type: string; url?: string; action?: string; id?: string }) => void,
) {
  if (!('serviceWorker' in navigator)) return () => {}
  const h = (e: MessageEvent) => cb(e.data ?? {})
  navigator.serviceWorker.addEventListener('message', h)
  return () => navigator.serviceWorker.removeEventListener('message', h)
}
